import { ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useLocale } from 'ra-core';
import { Notification } from '@/components/admin';

function AuthPageWrapper({ children }: { children: ReactNode }) {
  const locale = useLocale();

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY || ''}
      language={locale}
      useRecaptchaNet={false}
      useEnterprise
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <div className="relative flex min-h-svh flex-col items-center justify-center gap-6 overflow-hidden p-6 md:p-10">
        {/* Ambient aurora backdrop */}
        <div aria-hidden className="pointer-events-none absolute inset-0">
          <div
            className="absolute left-1/2 top-0 size-[520px] -translate-x-1/2 -translate-y-1/3 rounded-full opacity-[0.13] blur-[150px]"
            style={{ background: 'var(--gl-violet)' }}
          />
          <div
            className="absolute bottom-0 left-1/4 size-[440px] translate-y-1/3 rounded-full opacity-[0.11] blur-[150px]"
            style={{ background: 'var(--gl-cobalt)' }}
          />
          <div
            className="absolute right-0 top-1/3 size-[400px] translate-x-1/3 rounded-full opacity-[0.08] blur-[150px]"
            style={{ background: 'var(--gl-emerald)' }}
          />
        </div>
        <div className="relative flex w-full max-w-sm flex-col gap-6">
          {children}
        </div>
        <Notification />
      </div>
    </GoogleReCaptchaProvider>
  );
}

export default AuthPageWrapper;
